import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";

// Keep Vuetify's runtime theme aligned with the semantic Sass tokens in
// src/sass/variables.scss. Vuetify still needs concrete color values here.
const semanticThemeColors = {
  primary: "#1867C0",
  secondary: "#5CBBF6",
  background: "#FFFFFF",
  surface: "#ECEFF1",
  "surface-muted": "#E0E0E0",
  "toolbar-surface": "#455A64",
  "toolbar-surface-muted": "#78909C",
  "toolbar-surface-subtle": "#90A4AE",
  success: "#2E7D32",
  error: "#D32F2F",
};

export default createVuetify({
  display: {
    mobileBreakpoint: "sm",
    thresholds: {
      xs: 0,
      sm: 600,
      md: 744,
      lg: 1280,
      xl: 1920,
      xxl: 2560,
    },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          ...semanticThemeColors,
        },
      },
    },
  },
});
